import CountryFlag from '@/components/CountryFlag';
import ListboxControl from './ListboxControl';
import countries from './countries.json';

function CountryListItem({ name, code }) {
  return (
    <div className="flex items-center w-full space-x-3">
      <div className="text-xs font-medium bg-gray-200 px-3 rounded-full leading-5">
        {code}
      </div>
      <div>
        {name}
      </div>
    </div>
  );
}

function getCountries() {
  return Object.keys(countries).map((code) => ({
    value: code,
    label: (
      <CountryListItem name={countries[code]} code={code} />
    ),
  }));
}

export default function CountryListControl({
  value: countryCode,
  ...props
}) {
  return (
    <ListboxControl
      options={getCountries(countryCode)}
      value={countryCode}
      {...props}
    />
  );
}
